import { TOLGEE_GLOBALS } from 'utils'

export default [
  {
    label: 'Portuguese',
    URLValue: 'por',
    tolgeeKey: TOLGEE_GLOBALS.por,
  },
  {
    label: 'Spanish',
    URLValue: 'spa',
    tolgeeKey: TOLGEE_GLOBALS.spa,
  },
  {
    label: 'English',
    URLValue: 'eng',
    tolgeeKey: TOLGEE_GLOBALS.eng,
  },
  {
    label: 'Arabic',
    URLValue: 'ara',
    tolgeeKey: TOLGEE_GLOBALS.ara,
  },
  {
    label: 'French',
    URLValue: 'fra',
    tolgeeKey: TOLGEE_GLOBALS.fra,
  },
  {
    label: 'German',
    URLValue: 'deu',
    tolgeeKey: TOLGEE_GLOBALS.deu,
  },
  {
    label: 'Hindi',
    URLValue: 'hin',
    tolgeeKey: TOLGEE_GLOBALS.hin,
  },
  {
    label: 'Indonesian',
    URLValue: 'ind',
    tolgeeKey: TOLGEE_GLOBALS.ind,
  },
  {
    label: 'Italian',
    URLValue: 'ita',
    tolgeeKey: TOLGEE_GLOBALS.ita,
  },
  {
    label: 'Japanese',
    URLValue: 'jpn',
    tolgeeKey: TOLGEE_GLOBALS.jpn,
  },
  {
    label: 'Tagalog (Filipino)',
    URLValue: 'tgl',
    tolgeeKey: TOLGEE_GLOBALS.tgl,
  },
  {
    label: 'Chinês',
    URLValue: 'zho',
    tolgeeKey: TOLGEE_GLOBALS.zho,
  },
  {
    label: 'Korean',
    URLValue: 'kor',
    tolgeeKey: TOLGEE_GLOBALS.kor,
  },
  {
    label: 'Russian',
    URLValue: 'rus',
    tolgeeKey: TOLGEE_GLOBALS.rus,
  },
  {
    label: 'Thai',
    URLValue: 'tha',
    tolgeeKey: TOLGEE_GLOBALS.tha,
  },
]
